import { render, staticRenderFns } from "./GestioneProfili.vue?vue&type=template&id=96696a7e&scoped=true&"
import script from "./GestioneProfili.vue?vue&type=script&lang=js&"
export * from "./GestioneProfili.vue?vue&type=script&lang=js&"
import style0 from "./GestioneProfili.vue?vue&type=style&index=0&id=96696a7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96696a7e",
  null
  
)

export default component.exports